<template>
  <div class="contain" style="padding: 2.25rem 5vw;">
    <!-- 1. 添加全局loading遮罩：覆盖整个页面，加载时显示 -->
    <div v-if="loading" class="loading-mask">
      <el-spinner type="ring" color="#b62d2e" size="40px"></el-spinner>
    </div>

    <!-- 顶部标题+筛选区：移动端改为垂直布局 -->
    <div class="header-container">
      <div class="title-box">
        <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">
          學生表現 <span style="white-space: nowrap">Learning Performance</span>
          <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
            <span style="width: 0.8rem; height: 0.8rem; background: #b62d2e; border-radius: 50%; margin-right: 0.8rem"></span>
            <span style="width: 0.8rem; height: 0.8rem; background: #de5934; border-radius: 50%; margin-right: 0.8rem"></span>
            <span style="width: 0.8rem; height: 0.8rem; background: #f1aa55; border-radius: 50%; margin-right: 0.8rem"></span>
          </div>
        </div>
      </div>
      <!-- 外层容器：控制PC/手机端布局 -->
      <div class="select-container">
        <div class="purchase-box student-select">
          &nbsp;學生:&nbsp;
          <el-select v-model="selectUserId" placeholder="學生" @change="handleUserSelect" style="width: calc(100% - 60px);">
            <el-option
                v-for="item in studentCardList"
                :key="item.id"
                :label="item.userNo"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="purchase-box grade-select">
          &nbsp;年級:&nbsp;
          <el-select @change="gradeChange" v-model="selectGradeId" clearable placeholder="全部 All" style="width: calc(100% - 60px);">
            <el-option v-for="(item, index) in grades" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <!-- 整体数据区：移动端调整列布局和字体大小 -->
    <div class="overall-section">
      <el-row :gutter="16">
        <el-col :span="24">
          <div class="grid-content bg-purple" style="font-size: 1.2rem; line-height: 1.8rem; font-weight: bold; color: #b62d2e; margin-bottom: 0.5rem;">
            小測成績
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16" class="performance-row">
        <el-col :xs="12" :sm="12" :md="9" :lg="9" :xl="9">
          <div class="grid-content bg-purple-light" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 80px; padding: 0.5rem; position: relative; z-index: 1;">
            <p style="font-size: 2.5rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.star }}/{{learningPerformanceData.totalStar}}</p>
            <p style="font-size:18px; margin-top: 0.8rem;">星星總數</p>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="9" :lg="9" :xl="9">
          <div class="grid-content bg-purple" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 80px; padding: 0.5rem; position: relative; z-index: 1;">
            <p style="font-size: 2.5rem; line-height: 1rem; font-weight: bold; color: #b62d2e">{{ learningPerformanceData.overallPerformance }}</p>
            <p style="font-size:18px; margin-top: 0.8rem;">答對率</p>
          </div>
        </el-col>
        <!-- 移除原有图片标签，改为通过背景图实现 -->
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" style="display: flex; justify-content: center; align-items: center; position: relative; z-index: 1;">
          <div class="grid-content bg-purple-light">
            <!-- 空容器，背景图通过外层row控制 -->
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="margin-top: 0.5rem;">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark x2" style="height: 80px;display: flex;justify-content: right;align-items: flex-end;">
            <p style="font-size:18px;color: white;margin: 0;padding: 10px">學生：{{ selectUserNo }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 答题总数+学习时间：移动端单列/双列自适应 -->
    <div style="margin-top: 1rem;">
      <el-row :gutter="16">
        <el-col :span="24">
          <div class="grid-content bg-purple" style="font-size: 1.2rem; line-height: 1.8rem; font-weight: bold; color: #b62d2e; margin-bottom: 0.5rem;">
            整體表現
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin-bottom: 1rem;">
          <el-card shadow="always" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 1rem 0;">
            <span style="font-size: 1.2rem; line-height: 1rem;">答題總數&nbsp;&nbsp;</span>
            <span style="font-size: 1.5rem; line-height: 1rem; font-weight: bold; color: #b62d2e; margin-top: 0.5rem;">{{ learningPerformanceData.totalScore }}</span>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card shadow="always" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 1rem 0;">
            <span style="font-size: 1.2rem; line-height: 1rem;">總學習時間&nbsp;&nbsp;</span>
            <span style="font-size: 1.5rem; line-height: 1rem; font-weight: bold; color: #b62d2e; margin-top: 0.5rem;">{{ learningPerformanceData.totalAnsweringMinutes }}分鐘</span>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 最佳/最弱课题：移动端单列显示 -->
    <div style="margin-top: 1rem;">
      <el-row :gutter="16">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin-bottom: 1rem;">
          <el-card class="box-card" style="height: 100%;">
            <div slot="header" class="clearfix">
              <span style="font-size: 1.2rem; line-height: 1.8rem; font-weight: bold; color: #b62d2e">表現最佳課題</span>
              <el-button style="float: right; padding: 3px 0; font-size: 0.9rem;" type="text" @click="onDetailStudent">MORE</el-button>
            </div>
            <div v-for="(its, idx) in learningPerformanceData.topThreeProgresses" :key="idx" class="text item" style="font-size: 18px; line-height: 1.8rem; padding: 0.3rem 0;">
              {{its.topic.name == ''? its.topic.number:its.topic.name}}
              <div style="float: right;" type="text">
                <template>
                  <img style="height: 18px;" :src="its.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 18px;" :src="its.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 18px;" :src="its.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                </template>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-card class="box-card" style="height: 100%;">
            <div slot="header" class="clearfix">
              <span style="font-size: 1.2rem; line-height: 1.8rem; font-weight: bold; color: #b62d2e">表現最弱課題</span>
              <el-button style="float: right; padding: 3px 0; font-size: 0.9rem;" type="text" @click="onDetailStudent">MORE</el-button>
            </div>
            <div v-for="(its, idx) in learningPerformanceData.bottomThreeProgresses" :key="idx" class="text item" style="font-size: 18px; line-height: 1.8rem; padding: 0.3rem 0;">
              {{its.topic.name == ''? its.topic.number:its.topic.name}}
              <div style="float: right;" type="text">
                <template>
                  <img style="height: 18px;" :src="its.star > 0 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 18px;" :src="its.star > 1 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                  <img style="height: 18px;" :src="its.star > 2 ? require('@/assets/images/star-light.png') : require('@/assets/images/star-dark.png')" />
                </template>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { gender, paymentType } from "@/biz/static-data";
import { formatDate } from "@/filters";
import { getSubscriptionUpgradeDates } from "@/api/setting";
import {getLearningPerformance} from "@/api/topic";
import {getGrades} from "@/api/grade";
export default {
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      grades: [],
      selectUserId:null,
      selectUserNo:null,
      selectGradeId:null,
      studentAccountFrom: {
        id: null,
        userNo: null,
        name: null,
        gender: null,
        school: null,
        password: null,
        gradeId: null,
        avatar: null,
      },
      studentCardList: [],
      paymentType: [],
      studentIndex: null,
      dialogVisible: false,
      confirmUpgradeDate: "",
      autoUpgradeDate: "",
      learningPerformanceData: {},
      // 2. 添加loading状态变量（初始为false）
      loading: false
    };
  },
  watch: {//使用watch监听数据变化（适用于动态加载数据）
    studentCardList: {
      handler() {
        if (this.studentCardList.length > 0) {
          this.selectUserId = this.studentCardList[0].id;
          this.selectUserNo = this.studentCardList[0].userNo;
          this.selectGradeId = this.studentCardList[0].subscriptions[this.studentCardList[0].subscriptionIndex].gradeId;
          this.learningPerformance()
        }
      },
      immediate: true // 初始化时执行一次
    },
    "$store.getters.language": {
      handler(v) {
        //  this.getCarts()
        this.genders = gender[v];
        this.paymentType = paymentType[v];
        this.$forceUpdate();
      },
      deep: true,
    },
    detail(v) {
      this.studentCardList = v.students.filter((item) => {
        return item.subscriptions.length > 0 && item.status == 1;
      });
      this.$forceUpdate();
    },
  },
  computed: {
    needRenew() {
      let need = false;
      if (this.detail.students && this.detail.students.length > 0) {
        this.detail.students.forEach((item) => {
          if (item.status == 1 && !item.studentCode) {
            if (item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex) && item.subscriptionIndex == 0 && this.checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) != 0)
              need = true;
            if (item.subscriptions.length == 0) need = true;
          }
        });
      }
      return need;
    },
    needUpgrade() {
      if (this.confirmUpgradeDate && this.autoUpgradeDate) return this.$options.filters["isBetween"](new Date(), this.confirmUpgradeDate, this.autoUpgradeDate);
      else return false;
    },
  },
  created() {

  },
  mounted() {
    this.paymentType = paymentType[this.$store.getters.language];
    if (this.detail.students) {
      this.studentCardList = this.detail.students.filter((item) => {
        return item.subscriptions.length > 0 && item.status == 1;
      });
    }
    getSubscriptionUpgradeDates().then((v) => {
      let year = new Date().getFullYear() + "-";
      this.confirmUpgradeDate = year + v.data.confirmUpgradeDate;
      this.autoUpgradeDate = year + v.data.autoUpgradeDate;
    });

    setTimeout(() => {
      this.learningPerformance();
    }, 500);
    this.getGrades();
  },
  methods: {
    initial() {
      this.form = JSON.parse(JSON.stringify(this.detail));
      if (this.form.firstLogin == 0) {
        this.$router.push({ path: "/parentProfile" });
      }
    },
    enName(gradeName) {
      let enGradeList = {
        小一: "Primary One",
        小二: "Primary Two",
        小三: "Primary Three",
        小四: "Primary Four",
        小五: "Primary Five",
        小六: "Primary Six",
      };
      return enGradeList[gradeName];
    },
    gradeChange(id) {
      this.selectGradeId=id;
      this.learningPerformance();
    },
    getGrades() {
      getGrades().then((v) => {
        this.grades = v.data;
        this.$forceUpdate();
      });
    },
    // 3. 改造learningPerformance方法：添加loading控制
    learningPerformance() {
      // 3.1 先判断学生ID是否为空，为空则直接返回（不显示loading）
      if(this.selectUserId==null){
        return
      }

      // 3.2 开始加载：设置loading为true
      this.loading = true;

      let form = {
        studentId: this.selectUserId,
        gradeId: this.selectGradeId
      };

      // 3.3 调用接口：添加finally确保无论成功/失败都关闭loading
      getLearningPerformance(form)
          .then((v) => {
            this.learningPerformanceData = v.data;
          })
          .catch((err) => {
            console.error("获取学习表现失败：", err);
          })
          .finally(() => {
            // 3.4 接口完成（成功/失败）：关闭loading
            this.loading = false;
          });
      this.initial();
    },
    handleUserSelect(selectedId) {
      // 方法1：通过selectedId查找label（适用于value是id的场景）
      const selectedItem = this.studentCardList.find(item => item.id === selectedId);
      if (selectedItem) {
        const label = selectedItem.userNo;
        this.selectUserId = selectedId;
        this.selectUserNo = label;
        this.selectGradeId = selectedItem.subscriptions[selectedItem.subscriptionIndex].gradeId;
      }
      this.learningPerformance();
    },
    formatDate(date) {
      return formatDate(date);
    },
    onDetailStudent() {
      this.$router.push({
        path: "/studyRecord",
        query: {
          id: this.selectUserId,
          studentName: this.selectUserNo,
          gradeId: this.selectGradeId, // 修复：使用实际选中的年级ID，而非固定1
        },
      });
    },
    childByValue(v) {
      this.dialogVisible = v;
      this.$emit("getProfile");
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss" scoped>
// 4. 添加loading遮罩样式
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8); // 半透明白色背景
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; // 确保在最顶层显示
}

// 定义响应式断点变量
$phoneMaxWidth: 767px;
$minWidth: 768px;
$maxWidth: 1199px;

.x2 {
  background-image: url("~@/assets/images/x2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-size: 100% 100%;
}
.contain {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
}

// 顶部容器：移动端垂直布局
.header-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  @media (min-width: $minWidth) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}

.title-box {
  width: 100%;
  margin-bottom: 1rem;

  @media (min-width: $minWidth) {
    margin-bottom: 0;
  }
}

.purchase-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  padding: 0.5rem 0;

  @media (min-width: $minWidth) {
    justify-content: flex-end;
    height: 3.75rem;
  }

  // 适配移动端下拉框样式
  ::v-deep .el-select {
    margin: 0.2rem 0;

    .el-input__wrapper {
      padding: 0 0.5rem;
      font-size: 0.9rem;
    }
  }
}

// 整体数据区样式优化
.overall-section {
  margin-bottom: 1rem;
  width: 100%;
}

// 卡片样式适配
.box-card {
  height: 100%;
  box-sizing: border-box;

  ::v-deep .el-card__body {
    padding: 0.8rem;
  }
}

// 响应式调整
.el-icon-warning {
  font-size: 2rem;
  color: #d20000;
  position: absolute;
  top: -1rem;
  margin-left: 1rem;
}
.student-box {
  margin-top: 3rem;
}
.card-box {
  margin-bottom: 1.25rem;
  padding: 1rem;
  background: #f1aa55 url("~@/assets/images/student-card.png") top left/64% auto;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  img {
    margin: 1rem auto;
    width: 7.5rem;
    height: 7.5rem;
  }
  .card-detail {
    background: #ffffff;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    .card-detail-text {
      padding-bottom: 1rem;
      display: flex;
      div:nth-child(1) {
        color: #8e8e8e;
        flex: 1;
      }
      div:nth-child(2) {
        color: #444444;
        flex: 2;
      }
    }
  }
  .text-warn {
    color: #d20000;
  }
  .text-success {
    color: #008000;
  }
  .text-info {
    color: #936a10;
  }
  .box-warn {
    background: #fbe6e6;
    border: 1px #d20000 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-success {
    background: #e6f2e6;
    border: 1px #008000 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-info {
    background: #fffbe6;
    border: 1px #ffd700 solid;
    margin-top: 1.25rem;
    padding: 1.25rem 1.75rem;
    border-radius: 1rem;
    display: flex;
  }
  .box-icon {
    font-size: 1.6rem;
    margin-right: 0.5rem;
  }
  .box-info-icon {
    font-size: 1.2rem;
    padding: 0.2rem;
    line-height: 1;
    margin-right: 0.5rem;
    color: #fffbe6;
    background: #fcc03a;
    border-radius: 50%;
  }
}
.detail-button {
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  font-size: 18px;
  line-height: 1;
  padding: 0.75rem 2.25rem;
  background: #fcc03a;
  margin-bottom: 0.5rem;
  &.disabled {
    opacity: 0.6;
  }
}
.card-button {
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  color: #444444;
  border-radius: 1.625rem;
  line-height: 1.25;
  min-height: 2.2rem;
  background: #ffffff;
}

// 平板/桌面端样式
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  .contain {
    padding: 2.25rem 5vw;
  }

  .overall-section .grid-content {
    min-height: 100px;
  }

  .x2 {
    height: 100px;
  }
}

// 手机端核心适配样式
@media (max-width: $phoneMaxWidth) {
  html {
    font-size: 14px; // 缩小基础字体
  }

  .contain {
    padding: 1rem 3vw;
    height: 100%;
  }

  // 调整元素间距和大小
  .grid-content {
    font-size: 0.9rem !important;
  }

  .x2 {
    height: 80px !important;
  }

  // 卡片内文字适配
  ::v-deep .el-card {
    .el-card__header {
      padding: 0.8rem 1rem;
    }

    .el-card__body {
      padding: 0.8rem;
    }
  }

  // 下拉框适配
  ::v-deep .el-select {
    width: auto !important;
    min-width: 100px;

    .el-input__wrapper {
      min-height: 32px;
      padding: 0 0.5rem;
    }
  }

  // 按钮适配
  ::v-deep .el-button {
    font-size: 0.9rem;
    padding: 0.2rem 0.5rem;
  }

  // 对话框适配
  ::v-deep .el-dialog {
    width: 90% !important;
    border-radius: 1rem;

    .el-dialog__header {
      padding: 1rem 1rem 0;
    }

    .el-dialog__body {
      padding: 1rem;
    }

    .el-dialog__headerbtn {
      top: 1rem;
      right: 1rem;
    }
  }
}

// 对话框全局样式
::v-deep {
  .el-dialog {
    border-radius: 2.25rem;
    .el-dialog__headerbtn {
      font-size: 1.6rem;
      top: 2rem;
      right: 2rem;
    }
    .el-dialog__body {
      padding: 3rem 1.25rem;
    }
  }
}
// 定义断点：768px为PC/手机分界
$phoneMaxWidth: 767px;

// 外层容器：PC端弹性布局并排，手机端垂直布局
.select-container {
  display: flex;
  gap: 10px; // PC端两个下拉框之间的间距
  width: 100%;

  // 手机端样式
  @media (max-width: $phoneMaxWidth) {
    flex-direction: column;
    gap: 15px; // 手机端上下间距
  }
}

// 下拉框容器样式统一
.purchase-box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 0;

  // PC端每个下拉框占50%宽度
  @media (min-width: $phoneMaxWidth + 1px) {
    width: 50%;
  }

  // 适配Element UI下拉框样式
  ::v-deep .el-select {
    flex: 1;

    .el-input__wrapper {
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
}

// 可选：调整标签文字样式（可选）
.student-select, .grade-select {
  &:before {
    content: "";
    white-space: nowrap;
  }
}
.performance-row {
  // 核心：设置背景图并固定在右下角
  background-image: url("~@/assets/images/bear3.png");
  background-repeat: no-repeat;
  background-position: bottom right; // 右下角定位
  background-size: 120px auto; // 图片尺寸和原有一致
  min-height: 120px; // 保证背景图能完整显示
  position: relative; // 作为背景图的容器定位参考
  padding-right: 10px; // 避免图片贴边
  padding-bottom: 10px;

  // 响应式调整：手机端缩小背景图尺寸
  @media (max-width: 767px) {
    background-size: 65px auto;
    min-height: 100px;
  }
}

// 确保内容在背景图上方显示
.grid-content {
  position: relative;
  z-index: 1;
  border-radius: 8px; // 可选：增加圆角，视觉更美观
}
</style>